import { GeneralTable } from "@/shared/components/ui";
import { useCheckPermissionsArray, useTableFilter, useTableServerSideFiltering } from "@/shared/hooks";
import { Grid, IconButton, Tooltip } from "@mui/material";
import {
  EstadoProspectoEnum,
  TABLE_CONSTANTS,
} from "@/shared";
import { useState } from "react";
import { City, ISolicitudCanje, Province } from "@/shared/interfaces";
import { Visibility } from "@mui/icons-material";
import { useFetchSolicitudCanje } from "@/shared/actions/erp/marketing";
import { useTableColumnsMarketing } from "@/shared/hooks/useTableColumnsMarketing";
import { PermissionsEnum } from "@/auth/interfaces";
import ModalSolicitudCanje from "./ModalSolicitudesEventoCanje/ModalSolicitudCanje";

interface TableRevisionSolicitudCanjeProps {
  showCustomActionBtnSpace?: boolean
  enableEditing?: boolean
  estado_prospecto?: EstadoProspectoEnum
}

type DataSelectedParams = ISolicitudCanje & {
  provincia_data?: Province
  ciudad_data?: City
}

export default function TableRevisionSolicitudCanje({
  showCustomActionBtnSpace = true,
  enableEditing = true,

}: TableRevisionSolicitudCanjeProps) {

  useCheckPermissionsArray([
    PermissionsEnum.api_view_solicitudcanje,
    PermissionsEnum.api_change_solicitudcanje
  ]);

  ///* use state
  const [modal, setModal] = useState(false);
  const [dataSelected, setDataSelected] = useState<DataSelectedParams>();

  ///* Hooks
  const {
    ColumnsSolicitudCanje
  } = useTableColumnsMarketing();

  const {
    pagination,

    setPagination,
  } = useTableFilter();

  const { pageIndex } = pagination;

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { isLoading, data: SolicitudCanjeData, isRefetching } =
    useFetchSolicitudCanje({
      page: pageIndex + 1,
      ...filterObject,
      filterByState: false
    });





  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>

        </Grid>

        <Grid item xs={12}>
          <GeneralTable<ISolicitudCanje>
            columns={ColumnsSolicitudCanje}
            data={SolicitudCanjeData?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            ///* search
            enableGlobalFilter={false}
            enableSorting={false}
            // onGlobalFilterChange={setGlobalFilter}
            ///* pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={SolicitudCanjeData?.data?.count}
            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}

            // crud
            canEdit={false}
            enableEditing={enableEditing}
            showCustomActionBtnSpace={showCustomActionBtnSpace}
            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_MEDIUM}

            customActionBtnSpace={(value) => {
              return (
                <Grid container>
                  <Grid item >
                    <Tooltip title={'Ver Registro'} placement="top">
                      <IconButton
                        onClick={() => {
                          setModal(true)
                          setDataSelected(value!)
                        }
                        }
                      >
                        <Visibility />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </Grid>
              )
            }
            }
          />
        </Grid>
      </Grid>


      <ModalSolicitudCanje
      showModal={modal}
      setShowModal={setModal}
      dataSelected={dataSelected!}
      /> 


    </>

  );



}